import { setLogoutData } from '@/redux/slice/authSlice';
import { clearGraph } from '@/redux/slice/graphSlice';
import { clearToken } from '@/redux/slice/tokenSlice';
import { createContext, useState } from 'react';
import { useDispatch } from 'react-redux';

// Utils
export const authContext = createContext();

const AuthContextProvider = (props) => {
  const dispatch = useDispatch();
  // const [isAuthenticated, setIsAuthenticated] = useState(true);
  // const [email, setEmail] = useState();
  const ComingSoonList = {
    PerformanceDashboard: true,
    AccuracyDashboard: true,
    InfrastructureDashboard: true,
    ConsumerTrustIndex: true,
    Selection: false,
    TrustedConsumerScore: true,
    Webhook: true,
    FraudRiskType: true,
  };
  const [updatedShopperTrustedScore, setUpdatedShopperTrustedScore] = useState([]);
  const [isDataSubmissionLoading, setIsDataSubmissionLoading] = useState(false);
  const [isVideoGuideOpen, setIsVideoGuideOpen] = useState(false);
  // const [randNum, setRandNum] = useState();

  const logout = async () => {
    dispatch(setLogoutData());
    dispatch(clearToken());
    dispatch(clearGraph());
  };

  // useEffect(() => {
  //   setRandNum(getRandomInt(4));
  // }, []);

  return (
    <authContext.Provider
      value={{
        // isAuthenticated,
        // setIsAuthenticated,
        logout,
        // email,
        // setEmail,
        // randNum,
        updatedShopperTrustedScore,
        setUpdatedShopperTrustedScore,
        ComingSoonList,
        setIsDataSubmissionLoading,
        isDataSubmissionLoading,
        isVideoGuideOpen,
        setIsVideoGuideOpen,
      }}
    >
      {props.children}
    </authContext.Provider>
  );
};

export default AuthContextProvider;
